import React, { useState } from "react";

// Verification anti-robot maison : une addition simple a resoudre.
// 100% cote client, sans script tiers ni cookie (conforme a la politique de confidentialite).
// Le champ n'a pas d'attribut "name" : il n'est pas envoye a Netlify, il sert uniquement de garde.

function gen() {
  const a = 1 + Math.floor(Math.random() * 8);
  const b = 1 + Math.floor(Math.random() * 8);
  return { a, b };
}

export function useHumanCheck() {
  const [nums, setNums] = useState(gen);
  const [answer, setAnswer] = useState("");
  const isValid = parseInt(answer, 10) === nums.a + nums.b;
  const regenerate = () => {
    setNums(gen());
    setAnswer("");
  };
  return { a: nums.a, b: nums.b, answer, setAnswer, isValid, regenerate };
}

export const HumanCheckField = ({ check, dark = false, testid = "human-check" }) => (
  <div>
    <label
      htmlFor={testid}
      className={`block text-sm font-bold uppercase tracking-wide mb-2 ${dark ? "text-paper" : "text-ink"}`}
    >
      Vérification anti-robot : combien font {check.a} + {check.b} ?
    </label>
    <input
      id={testid}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={check.answer}
      onChange={(e) => check.setAnswer(e.target.value)}
      data-testid={testid}
      className={
        (dark
          ? "bg-paper text-ink border border-transparent"
          : "bg-white border border-line") +
        " w-full sm:max-w-[220px] rounded-[10px] px-4 py-3 text-base focus:outline-none focus:border-orange transition-colors duration-200"
      }
    />
  </div>
);
